import(/* webpackMode: "eager" */ "/home/autofrance.se/next-autofrance/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CompareToggleButton"] */ "/home/autofrance.se/next-autofrance/src/components/CompareToggleButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HittaRattDelar"] */ "/home/autofrance.se/next-autofrance/src/components/HittaRattDelar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/home/autofrance.se/next-autofrance/src/components/LocaleLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PassformEtikett"] */ "/home/autofrance.se/next-autofrance/src/components/PassformEtikett.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PhoneCtaBanner"] */ "/home/autofrance.se/next-autofrance/src/components/PhoneCtaBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QuickAddButton"] */ "/home/autofrance.se/next-autofrance/src/components/QuickAddButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WishlistToggleButton"] */ "/home/autofrance.se/next-autofrance/src/components/WishlistToggleButton.tsx");
